/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import format from 'date-fns/format';
import { injectIntl } from 'react-intl';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { getCenterAndZoom, drawOval, calLng, calLat } from 'lorautils/map';
import { isConnected } from 'lorautils/gateway';
import downloadAsCSV from 'lorautils/csvdl';
import WarningModal from 'loracoms/WarningModal';
import callAPI from '@/api/callAPI';
import { kAK, kOptsLg, kOptsSm, kDlKeys, kheader, kTimeFormat } from './consts';

import greenImg from '../../images/green.svg';
import redImg from '../../images/red.svg';
import yellowImg from '../../images/yellow.svg';
import defaultImg from '../../images/default.svg';
import orangeImg from '../../images/orange.svg';
import higherImg from '../../images/higher.svg';

import connectedImg from '../../images/connected.svg';
import disconnectedImg from '../../images/disconnected.svg';

const defaultProps = {
  onZoom: () => {},
  onDrag: () => {},
};

const propTypes = {
  intl: PropTypes.object.isRequired,
  time: PropTypes.object.isRequired,
  radius: PropTypes.number.isRequired,
  startDwnld: PropTypes.number.isRequired,
  colorState: PropTypes.object.isRequired,
  deviceState: PropTypes.array.isRequired,
  gatewayState: PropTypes.array.isRequired,
  updateState: PropTypes.any.isRequired,
  onZoom: PropTypes.func,
  onDrag: PropTypes.func,
};

class GpsMap extends React.Component {

  static gatewayInfo(gw) {
    return (
      `<div style="font-size:13px;">
          <p>${gw.name}</p>
      </div>`
    );
  }

  static info(obj, map) {
    let content = '';
    Object.keys(obj.metrics).forEach((key) => {
      content += ` <div class="row text-left"
                style="line-height:20px;border-bottom:1px solid #eee;">
              <div class="col-md-3 col-md-offset-3">${key}</div>
              <div class="col-md-3">${obj.metrics[key]}</div>
            </div>`;
    });
    return (
      `
<div style="font-size:13px;">
  <p class="clearfix">
    <span class="pull-left">${map[obj.nodeid]}</span>
    <span class="pull-right" style="margin-right: 10px;">${obj.name} ${format(obj.timestamp, 'MM-DD HH:mm:ss')}</span>
  </p>
  ${content}
</div>
`
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      colorState: props.colorState,
      showModal: false,
    };
    this.device = props.deviceState;
    this.deviceMap = {};
    this.markers = [];
    this.listeners = [];
    this.time = props.time;
    this.mapPoints = [];
    this.fetchPoints = {};
    this.transPoints = [];
    this.isTransform = false;
    this.gateway = props.gatewayState || [];
    this.radius = props.radius;
    this.gatewayMarker = [];
    this.ovals = [];
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.dashboard');
    this.limit = 10;
  }

  componentWillMount() {
    _.forEach(this.device, (d) => {
      if (d.deveui) {
        this.deviceMap[d.deveui] = d.name;
      }
    });
  }

  componentDidMount() {
    let tries = 0;
    const init = () => {
      try {
        this.initMap();
        this.handleCircle();
      } catch (e) {
        if (tries < 10) {
          tries += 1;
          setTimeout(init, 1000);
        }
      }
    };
    init();
  }

  componentWillReceiveProps(nextProps) {
    const {
      time,
      colorState,
      deviceState,
      gatewayState,
      radius,
      updateState,
      startDwnld,
    } = nextProps;

    if (!_.isEqual(time, this.props.time)) {
      this.time = time;
      this.refresh = false;
      this.mapPoints = [];
      this.clearMarker();
      this.loadData();
    }
    if (!_.isEqual(colorState, this.props.colorState)) {
      this.setState({ colorState }, () => {
        this.updateData('refresh');
      });
    }

    if (!_.isEmpty(deviceState) && !_.isEqual(deviceState, this.props.deviceState)) {
      this.device = _.filter(deviceState, (d) => {
        if (d.deveui) {
          this.deviceMap[d.deveui] = d.name;
        }
        return !_.isEmpty(d);
      });
      this.refresh = false;
      this.mapPoints = [];
      this.fetchPoints = {};
      this.clearMarker();
      this.loadData();
    }

    if (!_.isEqual(gatewayState, this.props.gatewayState)) {
      this.gateway = gatewayState;
      this.handleCircle();
    }
    if (radius !== this.props.radius) {
      this.radius = radius;
      this.handleCircle();
    }
    if (updateState !== this.props.updateState) {
      this.refresh = true;
      this.loadData();
    }

    if (startDwnld !== this.props.startDwnld) {
      this.handleDownload();
    }
  }

  componentWillUnmount() {
    _.map(_.zip(this.markers, this.listeners), ([marker, listener]) => {
      marker.removeEventListener('click', listener);
    });
    $('#gpsmap').empty();
  }

  initMap() {
    this.map = new BMap.Map('gpsmap');
    this.map.setMapStyle({ features: [] });
    this.map.setMaxZoom(19);
    this.map.setMinZoom(2);
    this.map.enableScrollWheelZoom();
    this.map.removeControl(this.navControl);
    this.map.removeControl(this.scaleControl);
    // eslint-disable-next-line
    this.navControl = new BMap.NavigationControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });
    // eslint-disable-next-line
    this.scaleControl = new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });

    this.map.addControl(this.navControl);
    this.map.addControl(this.scaleControl);
    this.map.addEventListener('zoomend', () => this.props.onZoom(this.map));
    this.map.addEventListener('dragend', () => this.props.onDrag(this.map));

    this.map.centerAndZoom('深圳', 1);

    if (this.map) {
      this.loadData();
    }
  }

  loadData() {
    if (!_.isEmpty(this.device)) {
      const { from } = this.time;
      const to = this.refresh ? new Date() : this.time.to;
      const promises = [];

      _.forEach(this.device, (d) => {
        if (d.deveui) {
          const p = callAPI({
            endpoint: '/lora/timeseries',
            method: 'POST',
            body: { nodeid: d.deveui, dps: ['snr', 'rssi', 'lat', 'lng'], from, to, limit: 1000 },
          });
          promises.push(p);
        }
      });

      Promise.all(promises).then((res) => {
        _.forEach(res, (r) => {
          this.mapPoints = _.concat(this.mapPoints, r.list || []);
        });

        // save previous dps to compare with update dps when refresh
        _.forEach(this.mapPoints, (l) => {
          if (!this.fetchPoints[l.nodeid]) {
            this.fetchPoints[l.nodeid] = {};
          }
          this.fetchPoints[l.nodeid][l.timestamp] = l;
        });

        if (this.refresh) {
          this.mapPoints = _.filter(this.mapPoints, l => (
            !this.fetchPoints[l.nodeid] || !this.fetchPoints[l.nodeid][l.timestamp]
          ));
        }
        this.updateData('transform');
      }).catch(() => {});
    }
  }

  updateData(type) {
    this.transPoints = type === 'transform' ? [] : this.transPoints;
    this.transCoords(type, (p, res, symbol) => {
      if (type === 'transform' && res.status === 0) {
        this.isTransform = true;
        const coords = res.result;

        let ps = p;
        ps = ps.map((item, idx) => {
          if (coords[idx]) {
            return {
              ...item,
              point: new BMap.Point(coords[idx].x, coords[idx].y),
            };
          }
          return null;
        });
        this.transPoints = _.concat(this.transPoints, ps);
        ps.forEach((obj) => {
          this.addMarker(obj);
        });

        const points = ps.map(x => x.point);
        if (points.length === 1 && (!this.refresh || this.map.getZoom() <= 3)) {
          this.map.centerAndZoom(points[0], 16);
        } else if (points.length > 0 && (!this.refresh || this.map.getZoom() <= 3)) {
          // decide max span with at most 100 points
          const [center, zoom] = getCenterAndZoom(points);
          if (!symbol && this.map.getZoom() <= 3) {
            this.map.centerAndZoom(center, zoom);
          }
        } else if (!this.refresh) {
          this.map.centerAndZoom('深圳', 1);
        }
      } else if (type === 'refresh' && this.isTransform) {
        this.clearMarker();
        this.transPoints.forEach((obj) => {
          this.addMarker(obj);
        });
      } else {
        this.map.centerAndZoom('深圳', 1);
      }
    });
  }

  handleDownload() {
    const { intl: { locale = 'zh' } } = this.props;
    if (this.mapPoints.length) {
      downloadAsCSV(
        this.mapPoints,
        `${format(new Date(), 'YYYYMMDDHHmmss')}.csv`,
        kDlKeys, kheader[locale], {
          timestamp: row => format(row.timestamp, kTimeFormat[locale]),
          name: row => this.deviceMap[row.nodeid],
        });
    } else {
      this.setState({ showModal: true });
    }
  }

  handleCircle() {
    if (this.gateway.length) {
      _.forEach(_.concat(this.ovals, this.gatewayMarker), l => this.map.removeOverlay(l));
      this.gatewayMarker = [];
      this.ovals = [];

      _.forEach(this.gateway, (gw) => {
        const { lastOn, lastOff, lat, lng } = gw;
        const gatewayImg = isConnected(lastOn, lastOff) ? connectedImg : disconnectedImg;

        if (!_.isNil(lat) && !_.isNil(lng)) {
          const point = new BMap.Point(lng, lat);
          const icon = new BMap.Icon(gatewayImg, new BMap.Size(20, 20));
          const marker = new BMap.Marker(point, { icon });
          const oval = new BMap.Polygon(drawOval(point, calLng(this.radius), calLat(this.radius)),
            {
              strokeColor: '#f89406',
              strokeWeight: 1,
              strokeOpacity: 1,
              fillColor: 'rgba(255,255,255,0.1)',
            });

          marker.addEventListener('click', () => {
            const info = GpsMap.gatewayInfo(gw);
            const infoWin = new BMap.InfoWindow(info, kOptsSm);
            this.map.openInfoWindow(infoWin, point);
          });
          this.gatewayMarker.push(marker);
          this.ovals.push(oval);
        }
      });

      _.forEach(_.concat(this.ovals, this.gatewayMarker), l => this.map.addOverlay(l));
      if (this.gatewayMarker.length) {
        const [center, zoom] = getCenterAndZoom([this.gatewayMarker]);
        this.map.centerAndZoom(center, zoom);
      }
    }
  }

  transCoords(type, callback) {
    if (type === 'transform') {
      const tobeTrans = [];
      let index = 0;

// if refresh
      this.mapPoints = this.mapPoints
        .filter((device) => {
          const { lat = '', lng = '' } = device.metrics;
          return lat && lng && lat !== '' && lng !== '' &&
              lng !== '0' && lat !== '0' &&
            (Number(lng) >= -180 && Number(lng) <= 180) &&
            (Number(lat) >= -90 && Number(lat) <= 90);
        });

      this.maxCount = Math.ceil(this.mapPoints.length / 100);

      if (this.mapPoints.length) {
        for (let i = 0; i < this.maxCount; i += 1) {
          const temp = this.mapPoints.slice(i * 100, (i + 1) * 100);
          tobeTrans.push(temp);
        }

        const loop = () => {
          if (index < this.maxCount) {
            const arr = tobeTrans[index];
            if (arr.length) {
              const coords = arr
                .map((device) => {
                  const { metrics: { lng, lat } } = device;
                  return `${lng},${lat}`;
                }).join(';');
              $.ajax({
                url: `https://api.map.baidu.com/geoconv/v1/?coords=${coords}&from=1&to=5&ak=${kAK}&callback=?`,
                dataType: 'jsonp',
                success(res) {
                  const symbol = index !== 0;
                  callback(arr, res, symbol);
                  index += 1;
                  loop();
                },
              });
            }
          }
        };
        loop();
      } else if (!this.refresh) {
        this.map.centerAndZoom('深圳', 1);
      }
    } else if (type === 'refresh') {
      callback();
    }
  }

  addMarker(item) {
    const { colorState: { type, green, yellow, red } } = this.state;
    let img = defaultImg;
    const crtVal = Number(item.metrics[type]);
    try {
      if (crtVal > Number(green.max)) {
        img = higherImg;
      } else if (crtVal >= Number(green.min) && crtVal <= Number(green.max)) {
        img = greenImg;
      } else if (crtVal >= Number(yellow.min) && crtVal <= Number(yellow.max)) {
        img = yellowImg;
      } else if (crtVal >= Number(red.min) && crtVal <= Number(red.max)) {
        img = orangeImg;
      } else if (crtVal < Number(red.min)) {
        img = redImg;
      }
    } catch (err) {
    //  nothing to do width err
    }
    const openInfo = () => {
      const info = GpsMap.info(item, this.deviceMap);
      const infoWin = new BMap.InfoWindow(info, kOptsLg);
      this.map.openInfoWindow(infoWin, item.point);
    };
    const icon = new BMap.Icon(img, new BMap.Size(48, 48));
    const marker = new BMap.Marker(item.point, { icon });
    marker.addEventListener('click', openInfo);

    this.map.addOverlay(marker);
    this.markers.push(marker);
    this.listeners.push(openInfo);
  }

  clearMarker() {
    this.markers.forEach((marker) => {
      this.map.removeOverlay(marker);
    });
  }

  render() {
    return (
      <div style={{ height: '100%', width: '100%' }} >
        <div id="gpsmap" style={{ height: '100%', width: '100%' }} />
        <WarningModal
          showModal={this.state.showModal}
          onHide={() => this.setState({ showModal: false })}
          text={this.intlMsg.msg('download.nodata')}
          header={this.intlMsg.msg('download.header')}
        />
      </div>
    );
  }
}


GpsMap.defaultProps = defaultProps;
GpsMap.propTypes = propTypes;

const mapStateToProps = state => ({
  time: state.roadtest.getTimes,
  colorState: state.roadtest.getGpsColor,
  deviceState: state.roadtest.getDevice,
  gatewayState: state.roadtest.getGateway,
  radius: state.roadtest.getRadius,
  startDwnld: state.roadtest.startDwnld,
  updateState: state.roadtest.updateGps,
});

export default connect(
  mapStateToProps,
  null,
)(injectIntl(GpsMap));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/RoadTestView/coms/GpsMap/index.jsx